import React from "react";

function BasketballEvent() {
  return (
    <div>
      <section className="basketball-event">
        <div className="container">
          <div className="combat-feature-content">
            <h2 className="combat-feature-title futuraPTBold">
              Book the Court. Build
              <br />
              the Competition.
            </h2>

            <p className="combat-feature-text">
              Book your next basketball tournament, league, camp, clinic, or
              showcase at ADS Sports Complex. With multiple indoor courts,
              flexible event configurations, and space for athletes, coaches,
              and spectators, our facility provides everything you need to
              create a seamless, high-energy basketball experience from
              tipoff to the final buzzer.
            </p>

            <a href="/BookEvent" className="btn combat-feature-button">
              BOOK YOUR BASKETBALL EVENT
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BasketballEvent;
